// extracted by mini-css-extract-plugin
module.exports = {"link":"_2yXCL","image":"DFk41","root":"_2TxBB"};